import { Popover, PopoverProps } from 'antd';
import { IconProps, X } from 'react-feather';

interface Props extends PopoverProps {
  onClick?: () => void;
  iconProps?: IconProps;
  disabled?: boolean;
}

const RefuseIcon: React.FC<Props> = ({
  onClick,
  iconProps,
  disabled,
  ...props
}) => {
  return (
    <Popover {...props} content={props.content || 'Recusar'}>
      <X
        style={disabled ? { cursor: 'not-allowed' } : {}}
        color={disabled ? 'darkgray' : 'red'}
        size={20}
        cursor={'pointer'}
        onClick={!disabled ? onClick : undefined}
        {...iconProps}
      />
    </Popover>
  );
};

export default RefuseIcon;
